import { gql } from '@apollo/client';

export const CLASS_ACTIVITY = gql`
  query classActivity($input: ClassActivityInput!) {
    classActivity(input: $input) {
      classId
      classSummary {
        startTime
        endTime
        studySessionsCompleted
        studySessionsClosed
        nuggetsCompleted
        nuggetsClosed
        questionsAnswered {
          mean
          median
          sum
        }
        questionsAnsweredCorrectly {
          mean
          median
          sum
        }
        durationActualSec {
          mean
          median
          sum
        }
        percentScore {
          latest {
            mean
            median
            sum
          }
        }
      }
      userSummaries {
        user {
          userId
          firstName
          lastName
          avatar
        }
        summary {
          startTime
          endTime
          studySessionsCompleted
          studySessionsClosed
          nuggetsCompleted
          nuggetsClosed
          questionsAnswered {
            mean
            median
            sum
          }
          questionsAnsweredCorrectly {
            mean
            median
            sum
          }
          durationActualSec {
            mean
            median
            sum
          }
          percentScore {
            latest {
              mean
              median
              sum
            }
          }
        }
      }
      prePaginationCount
    }
  }
`;

export const CLASS_COURSE_LIST = gql`
  query classCourseList($input: ClassCourseListInput!) {
    classCourseList(input: $input) {
      classId
      courses {
        courseId
        name
        icon {
          iconCode
          name
          url
        }
        subject {
          labelId
          name
          parentId
        }
      }
    }
  }
`;

export const CLASS_COURSE_LIST_WITH_STRANDS = gql`
  query classCourseList($input: ClassCourseListInput!) {
    classCourseList(input: $input) {
      classId
      courses {
        courseId
        name
        icon {
          iconCode
          name
          url
        }
        subject {
          labelId
          name
          parentId
        }
      }
      strands {
        strandId
        name
      }
    }
  }
`;

export const CLASS_NUGGET_ACTIVITY = gql`
  query classNuggetActivity($input: ClassNuggetActivityInput!) {
    classNuggetActivity(input: $input) {
      classId
      nuggetDetailsAndActivity {
        nuggetDetails {
          nuggetId
          name
        }
        nuggetActivity {
          usersActive
          usersFinished
          usersTotal
          percentUsersActive
          percentUsersFinished
          attemptsAll {
            median
            sum
            mean
          }
          attemptsClosed {
            median
            sum
            mean
          }
          attemptsCompleted {
            median
            sum
            mean
          }
          percentScore {
            median
            sum
            mean
          }
          durationActual {
            median
            sum
            mean
          }
          durationTotal {
            median
            sum
            mean
          }
          questionsAnswered {
            median
            sum
            mean
          }
          questionsAnsweredCorrectly {
            median
            sum
            mean
          }
        }
      }
      prePaginationCount
    }
  }
`;
